import { useEffect, useRef, useState } from 'react';

export default function FacilitiesSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="facilities"
      ref={sectionRef}
      className="relative w-full h-screen min-h-[600px] overflow-hidden"
    >
      {/* Background Image with Parallax-like fixed attachment */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=abstract%20artistic%20map%20of%20Latin%20America%20continent%20with%20golden%20glowing%20network%20connections%20flowing%20across%20the%20landmass%20luxury%20perfume%20essence%20droplets%20floating%20above%20elegant%20warm%20amber%20tones%20dark%20sophisticated%20background%20professional%20artistic%20illustration%20connecting%20regions%20perfumery%20business%20expansion&width=1400&height=900&seq=latam-expansion-bg&orientation=landscape)',
        }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/50" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6">
            Llevando calidad y esencia a toda la región
          </h2>
          <div className="w-12 h-0.5 bg-white/60 mx-auto mb-6" />
          <p className="text-white/80 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Esencia & co continúa expandiendo su red de distribución en Latinoamérica, llevando calidad, innovación y respaldo estratégico a negocios de perfumería en México, Panamá, Colombia, Venezuela, Ecuador, Bolivia y República Dominicana.
          </p>
        </div>
      </div>
    </section>
  );
}